const es = {
  common: {
    appName: 'Sistema de Monitoreo de Opinión Pública',
    loading: 'Cargando...',
    noData: 'Sin datos',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Guardar',
    edit: 'Editar',
    delete: 'Eliminar',
    add: 'Añadir',
    search: 'Buscar',
    export: 'Exportar',
    back: 'Volver',
    next: 'Siguiente',
    prev: 'Anterior',
    submit: 'Enviar',
    reset: 'Restablecer',
    close: 'Cerrar',
    all: 'Todos',
    total: 'Total',
    actions: 'Acciones',
    status: 'Estado',
    type: 'Tipo',
    name: 'Nombre',
    time: 'Hora',
    operation: 'Operación',
    success: 'Éxito',
    failed: 'Fallido',
    yes: 'Sí',
    no: 'No',
    page: 'Página',
    of: 'de',
    items: 'elementos',
    selectPlaceholder: 'Por favor seleccione',
    inputPlaceholder: 'Por favor ingrese',
    viewOriginal: 'Ver original',
  },
  nav: {
    dashboard: 'Panel Principal',
    monitor: 'Monitoreo',
    monitorManage: 'Gestión de Monitoreo',
    monitorData: 'Monitoreo de Datos',
    analysis: 'Análisis',
    volume: 'Monitor de Volumen',
    publicOption: 'Análisis de Eventos',
    report: 'Informes',
    settings: 'Configuración',
    settingsWarning: 'Configuración de Alertas',
    settingsWarningMsg: 'Mensajes de Alerta',
    settingsPreference: 'Preferencias',
    settingsFeedback: 'Comentarios',
  },
  login: {
    title: 'Iniciar Sesión',
    subtitle: 'Sistema de Monitoreo de Opinión Pública',
    phone: 'Número de Teléfono',
    phonePlaceholder: 'Ingrese su número de teléfono',
    password: 'Contraseña',
    passwordPlaceholder: 'Ingrese su contraseña',
    signIn: 'Iniciar Sesión',
    signingIn: 'Iniciando sesión...',
    logout: 'Cerrar Sesión',
    invalidCredentials: 'Número de teléfono o contraseña incorrectos',
  },
  dashboard: {
    title: 'Panel Principal',
    todayStatus: 'Estado de Opinión Pública de Hoy',
    warningAlerts: 'Alertas de Advertencia',
    hotEvents: 'Eventos Destacados',
    hotSearch: 'Términos de Búsqueda Populares',
    leadersOpinion: 'Opinión Pública de Líderes',
    pushOpinion: 'Opiniones Enviadas',
    reprintQuery: 'Consulta de Reimpresión',
    collection: 'Publicaciones Recogidas',
    hotWeibo: 'Tendencias en Weibo',
    hotWechat: 'Tendencias en WeChat',
    hotDouyin: 'Tendencias en Douyin',
    hotBilibili: 'Tendencias en Bilibili',
    onlineUsers: 'Usuarios en Línea',
    dailyReport: 'Informe Diario',
    weeklyReport: 'Informe Semanal',
  },
  monitor: {
    title: 'Gestión de Monitoreo',
    addGroup: 'Añadir Grupo',
    editGroup: 'Editar Grupo',
    deleteGroup: 'Eliminar Grupo',
    addProject: 'Añadir Proyecto',
    editProject: 'Editar Proyecto',
    deleteProject: 'Eliminar Proyecto',
    groupName: 'Nombre del Grupo',
    projectName: 'Nombre del Proyecto',
    projectType: 'Tipo de Proyecto',
    normal: 'Normal',
    advanced: 'Avanzado',
    subjectWord: 'Palabras Clave Principales',
    characterWord: 'Palabras de Personajes',
    eventWord: 'Palabras de Eventos',
    regionalWord: 'Palabras Regionales',
    stopWord: 'Palabras Excluidas',
    projectDescription: 'Descripción',
    selectProject: 'Seleccione un proyecto desde la gestión de monitoreo',
    deleteConfirm: '¿Está seguro de que desea eliminar?',
    groupDeleteConfirm: 'Eliminar este grupo también eliminará todos los proyectos en él. ¿Desea continuar?',
    dataList: 'Monitoreo de Datos',
    articleTitle: 'Título del Artículo',
    sourceName: 'Fuente',
    publishTime: 'Hora de Publicación',
    emotion: 'Emoción',
    positive: 'Positivo',
    neutral: 'Neutral',
    negative: 'Negativo',
    similarCount: 'Recuento de Similares',
    sourcePlatform: 'Plataforma de origen',
    keyword: 'Palabra Clave',
    timeRange: 'Rango de Tiempo',
    hours24: '24 Horas',
    today: 'Hoy',
    yesterday: 'Ayer',
    days3: '3 Días',
    days7: '7 Días',
    days15: '15 Días',
    days30: '30 Días',
    days365: '1 Año',
    custom: 'Personalizado',
    emotionFilter: 'Filtro de Emoción',
    sourceFilter: 'Filtro de Fuente',
    sortBy: 'Ordenar Por',
    timeDesc: 'Tiempo Descendente',
    timeAsc: 'Tiempo Ascendente',
    similarDesc: 'Similares Descendente',
    matchMode: 'Modo de Coincidencia',
    fullText: 'Texto Completo',
    titleOnly: 'Solo Título',
    contentOnly: 'Solo Contenido',
    preciseFilter: 'Filtro Preciso',
    mergeSimilar: 'Fusionar Similares',
    sourcePlatforms: 'Plataformas de origen',
    sourcePlatformsHint: 'Selecciona las plataformas a monitorear',
    platformsCount: 'plataformas',
    projectPlatforms: 'Plataformas del proyecto',
    sourcePlatformFilter: 'Plataforma de origen',
  },
  analysis: {
    title: 'Análisis de Monitoreo',
    dataOverview: 'Resumen de Datos',
    emotionalProportion: 'Proporción de Emociones',
    planWordHit: 'Coincidencias de Palabras Principales',
    keywordEmotionTrend: 'Tendencia de Emociones de Palabras Clave',
    hotEventRanking: 'Ranking de Eventos Destacados',
    highwordCloud: 'Nube de Palabras Clave',
    keywordIndex: 'Índice de Palabras Frecuentes',
    mediaActivity: 'Análisis de Actividad de Medios',
    hotSpotRanking: 'Ranking de Puntos Calientes',
    dataSourceDistribution: 'Distribución de Fuentes de Datos',
    dataSourceAnalysis: 'Análisis de Fuentes de Datos',
    keywordExposureRank: 'Ranking de Exposición de Palabras Clave',
    selfmediaVolumeRank: 'Ranking de Volumen de Automedios',
    popularInformation: 'Información Popular',
    popularEvent: 'Eventos Populares',
    hotCompany: 'Empresas Destacadas',
    hotPeople: 'Personas Destacadas',
    hotSpot: 'Lugares Destacados',
    relativeNews: 'Noticias Relacionadas',
    categoryRank: 'Tendencia de Categorías',
    industrialDistribution: 'Distribución Industrial',
    eventStatistics: 'Estadísticas de Eventos',
    keywordEmotionStatistical: 'Estadísticas de Emociones de Palabras Clave',
    timePeriod: 'Período de Tiempo',
    update: 'Actualizar Análisis',
    totalArticles: 'Total de Artículos',
    newsCount: 'Recuento de Noticias',
    socialCount: 'Recuento de Redes Sociales',
  },
  volume: {
    title: 'Monitor de Volumen',
    totalVolume: 'Volumen Total',
    newsVolume: 'Volumen de Noticias',
    socialVolume: 'Volumen Social',
    keywordEmotionStatistical: 'Estadísticas de Emociones de Palabras Clave',
    keywordSourceDistribution: 'Distribución de Fuentes de Palabras Clave',
    keywordNewsRank: 'Ranking de Noticias de Palabras Clave',
    topicClusterAnalysis: 'Análisis de Agrupación de Temas',
    keywordEmotionTrend: 'Tendencia de Emociones de Palabras Clave',
    highwordCloud: 'Nube de Palabras Clave',
    keywordExposureRank: 'Ranking de Exposición de Palabras Clave',
    keywordCorrelationNews: 'Ranking de Agrupación de Contenido Destacado',
    userPortraitLabel: 'Etiquetas de Perfil de Usuario',
    socialUserVolumeRank: 'Ranking de Volumen de Usuarios de Redes Sociales',
    mediaUserVolumeRank: 'Ranking de Volumen de Usuarios de Automedios',
  },
  publicOption: {
    title: 'Análisis de Eventos',
    addEvent: 'Crear Evento',
    editEvent: 'Editar Evento',
    deleteEvent: 'Eliminar Evento',
    eventName: 'Nombre del Evento',
    eventKeywords: 'Palabras Clave del Evento',
    eventStartTime: 'Hora de Inicio',
    eventEndTime: 'Hora de Fin',
    eventStopWords: 'Palabras Excluidas',
    reportList: 'Lista de Informes',
    reportDetail: 'Detalle del Informe',
    backAnalysis: 'Análisis de Trazabilidad',
    eventContext: 'Contexto del Evento',
    eventTrace: 'Seguimiento del Evento',
    hotAnalysis: 'Análisis Destacado',
    netizensAnalysis: 'Análisis de Internautas Clave',
    statistics: 'Estadísticas',
    propagationAnalysis: 'Análisis de Propagación',
    thematicAnalysis: 'Análisis Temático',
    unscrambleContent: 'Interpretación de Contenido',
    judicialOpinion: 'Análisis de Opinión Pública Judicial',
    statusCreating: 'Creando',
    statusFailed: 'Creación Fallida',
    statusSuccess: 'Creado Exitosamente',
  },
  report: {
    title: 'Informes de Análisis',
    dailyReport: 'Informe Diario',
    weeklyReport: 'Informe Semanal',
    monthlyReport: 'Informe Mensual',
    reportName: 'Nombre del Informe',
    reportType: 'Tipo de Informe',
    reportPeriod: 'Período del Informe',
    reportStatus: 'Estado del Informe',
    generating: 'Tarea Generada',
    editing: 'Editando',
    completed: 'Completado',
    failed: 'Fallido',
    deleteSelected: 'Eliminar Seleccionados',
    compile: 'Compilar',
    viewDetail: 'Ver Detalle',
    dataOverview: 'Resumen de Datos',
    emotionAnalysis: 'Análisis de Emociones',
    hotEventRanking: 'Ranking de Eventos Destacados',
    mediaActivity: 'Análisis de Actividad de Medios',
    selfMediaRanking: 'Ranking de Automedios',
    highWordIndex: 'Índice de Palabras Frecuentes',
    hotSpotRanking: 'Ranking de Puntos Calientes',
    netizenWordCloud: 'Nube de Palabras de Internautas',
    mediaWordCloud: 'Nube de Palabras de Medios',
    hotPeople: 'Personas Destacadas',
    hotSpots: 'Lugares Destacados',
    topicClustering: 'Análisis de Agrupación de Temas',
    socialVRanking: 'Ranking de Influencers de Redes Sociales',
  },
  settings: {
    title: 'Configuración del Sistema',
    warning: {
      title: 'Configuración de Alertas',
      warningName: 'Nombre de Alerta',
      warningWord: 'Palabras de Alerta',
      warningSwitch: 'Interruptor de Alerta',
      warningClassify: 'Tipo de Fuente',
      warningContent: 'Contenido de Alerta',
      allContent: 'Todo',
      sensitiveOnly: 'Solo Sensible',
      warningMatch: 'Modo de Coincidencia',
      warningDeduplication: 'Deduplicación de Alerta',
      warningSource: 'Fuente de Alerta',
      systemPush: 'Push del Sistema',
      emailPush: 'Push por Correo',
      receiveTime: 'Tiempo de Recepción',
      weekendWarning: 'Alerta de Fin de Semana',
      warningInterval: 'Intervalo de Alerta',
      realtime: 'Tiempo Real',
      scheduled: 'Programado',
      messageList: 'Mensajes de Alerta',
      edit: 'Editar Alerta',
    },
    preference: {
      title: 'Preferencias',
      timeRange: 'Rango de Tiempo',
      preciseFilter: 'Filtro Preciso',
      emotion: 'Emoción',
      similar: 'Artículos Similares',
      sort: 'Orden de Información',
      matchMode: 'Modo de Coincidencia',
      dataSource: 'Fuente de Datos',
      websiteName: 'Nombre del Sitio Web',
      author: 'Autor',
      organization: 'Organización',
      categoryLabel: 'Categoría de Artículo',
      enterpriseType: 'Tipo de Empresa',
      highTechType: 'Empresa de Alta Tecnología',
      policyLabel: 'Política',
      dataSourceType: 'Categoría de Datos',
      eventIndex: 'Evento',
      industryIndex: 'Industria',
      province: 'Provincia',
      city: 'Ciudad',
    },
    feedback: {
      title: 'Comentarios y Sugerencias',
      content: 'Sus Comentarios',
      submit: 'Enviar Comentarios',
    },
  },
}

export default es
